<template>
  <div>

  </div>
</template>

<script>
  export default {

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pages/vehicle/detail/Activity.vue